export const FILTERS = [
  { key: "all", label: "Tout voir", cls: "ftag-all" },
  { key: "form", label: "Formation", cls: "ftag-form" },
  { key: "exp", label: "Expérience", cls: "ftag-exp" },
  { key: "stage", label: "Stage", cls: "ftag-stage" },
];

export const ENTRIES = [
  {
    cat: "exp",
    type: "CDD · 3 mois",
    title: "Développeur de plateforme digitale",
    org: "MATARIKI — Paris",
    date: "2025",
    desc: "Travail sur une plateforme digitale en React et Python. Contribution aux projets internes et au développement des activités dans les domaines data & IA.",
    tags: ["React", "Python", "Data & IA"],
    current: true,
  },
  {
    cat: "exp",
    type: "Alternance · 2 ans",
    title: "Développeur full-stack",
    org: "V6Protect — Bordeaux",
    date: "2023 – 2025",
    desc: "Développement sur une application multicouches sur le thème de la cybersécurité. Première année en alternance à Webtech Institute, deuxième année à l'EPSI (Mastère Expert en Systèmes d'Information 2024–2025).",
    tags: ["React", "Node.js", "NestJS", "Cybersécurité"],
  },
  {
    cat: "exp",
    type: "Alternance · 1 an",
    title: "Développeur full-stack",
    org: "Métarom — Amiens",
    date: "2022 – 2023",
    desc: "Première grande expérience professionnelle dans une entreprise d'arômes. Développement d'une application de formation interne avec vidéo, montage et interfaces métier. Rencontres avec les différents services pour analyser les besoins.",
    tags: ["React", "Laravel", "Figma", "Conduite de projet"],
  },
  {
    cat: "form",
    type: "Formation",
    title: "Expert en Systèmes d'Information",
    org: "EPSI",
    date: "2024 – 2025",
    desc: "2ème année de Mastère en parcours expert informatique. Formation orientée architecture et systèmes d'information complexes.",
    tags: ["Architecture SI", "Mastère 2"],
  },
  {
    cat: "form",
    type: "Formation",
    title: "Mastère Full-Stack Development",
    org: "Webtech Institute",
    date: "2023 – 2024",
    desc: "Formation orientée full-stack avec une dimension cybersécurité, pour renforcer la maîtrise du code côté serveur et sécuriser les applications.",
    tags: ["Full-Stack", "Cybersécurité", "Mastère"],
  },
  {
    cat: "form",
    type: "Formation",
    title: "Bachelor Web & Application Developer",
    org: "La Manu — Le Havre",
    date: "2020 – 2023",
    desc: "3 ans de formation en développement web et applicatif, incluant deux stages et une alternance de 1 an en entreprise. Diplôme obtenu en 3ème année diplômante.",
    tags: ["React", "PHP", "JavaScript", "Git", "Bachelor"],
  },
  {
    cat: "stage",
    type: "Stage · 3 mois",
    title: "Développeur d'application",
    org: "La Fabrique à Biscuits — Le Havre",
    date: "2021",
    desc: "Conception d'une application web de gestion des ressources internes avec Symfony pour le compte d'une entreprise agro-alimentaire.",
    tags: ["Symfony", "PHP", "Gestion interne"],
  },
  {
    cat: "stage",
    type: "Stage · 2 mois",
    title: "Développeur web",
    org: "Trust Yourself — Le Havre",
    date: "2020",
    desc: "Création d'un site web dans le cadre d'une formation en anglais. Premier contact avec le développement web professionnel.",
    tags: ["Wordpress", "Divi"],
  },
  {
    cat: "form",
    type: "Formation",
    title: "Bac Pro BIT - Bio-Industries de Transformation",
    org: "Lycée — Yvetot",
    date: "2017 – 2020",
    desc: "Formation axée sur les procédés de transformation agroalimentaire, qualité et hygiène industrielle. Première approche des systèmes automatisés et de l'informatique industrielle.",
    tags: ["Agroalimentaire", "Procédés industriels", "Qualité"],
  },
];

export const DOT_COLORS = {
  form: "#1D9E75",
  exp: "#378ADD",
  stage: "#BA7517",
};
